import { createAsyncThunk } from "@reduxjs/toolkit";
import { Chart } from "../../interfaces/interfaces";
import ActiveAlerts from "../../pages/CollaborationHub/Components/alertSection/activeAlerts/activeAlerts";
import { RestS } from "../../rest/rest-service";

export const fetchAsyncDataAlertSummary = createAsyncThunk(
  "dataAlerts/fetchAsyncDataAlertSummary",
  async (userId: string, { rejectWithValue }) => {
    try {
      const data = await RestS.getDataAlertSummary();
      return data;
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const fetchAsyncActiveAlerts = createAsyncThunk(
  "dataAlerts/fetchActiveAlerts",
  async (reportId: number, { rejectWithValue }) => {
    try {
      const data = await RestS.getActiveAlerts(reportId);
      return { activeAlerts: data };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const fetchAsyncTriggerAlertHistory = createAsyncThunk(
  "dataAlerts/fetchTriggerAlertHistory",
  async (alertId: number, { rejectWithValue }) => {
    try {
      const data = await RestS.getTriggeredAlertsHistory(alertId);
      return { alertId, triggeredAlertHistory: data };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

type FetchChartsPayload = {
  reportVersionsIds: number[];
  chartIdentifier: string;
};

export const fetchAsyncCharts = createAsyncThunk(
  "dataAlerts/fetchAsyncCharts",
  async (
    { reportVersionsIds, chartIdentifier }: FetchChartsPayload,
    { rejectWithValue }
  ) => {
    try {
      const data = await RestS.getUpdateChartRange(
        reportVersionsIds,
        chartIdentifier
      );
      return { charts: data } as { charts: Chart[] };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const fetchAsyncTriggeredAlerts = createAsyncThunk(
  "dataAlerts/fetchAsyncTriggeredAlerts",
  async (reportId: number, { rejectWithValue }) => {
    try {
      const data = await RestS.getTriggeredAlerts(reportId);
      return { triggeredAlerts: data };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);
